import styled from "styled-components";
import { Button } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import type { FC } from "react";
import type { IProModal } from "pro-features/components/Modals/src/ProModal";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
const i18n = i18nFilter();

const ButtonStyle = styled(Button)`
    align-self: end;
`;
const TitleStyle = styled.span`
    margin-bottom: 36px;
    ${setFontVariant("h5", colorsPalettes.carbon[500])}
`;
const SubtitleStyle = styled.span`
    margin-bottom: 40px;
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
`;

const ProModalStyled = styled(ProModal)<IProModal>`
    width: 494px;
    height: 140px;
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
    padding: 20px 32px 24px 24px;
`;

interface INoAccessSegmentModal {
    isOpen: boolean;
    onCloseModal: (shouldShow: boolean) => void;
}
export const NoAccessSegmentModal: FC<INoAccessSegmentModal> = ({ onCloseModal, isOpen = false }) => {
    const titleText = i18n("no.access.segment.modal.title");
    const subtitleText = i18n("no.access.segment.modal.subtitle");
    const buttonText = i18n("no.access.segment.modal.button");

    const onButtonClick = () => {
        onCloseModal(false);
    };

    return (
        <ProModalStyled
            isOpen={isOpen}
            showCloseIcon={false}
        >
            <TitleStyle>{titleText}</TitleStyle>
            <SubtitleStyle>{subtitleText}</SubtitleStyle>
            <ButtonStyle
                type="flat"
                onClick={onButtonClick}
            >
                {buttonText}
            </ButtonStyle>
        </ProModalStyled>
    );
};
